import http from '@/plugins/axios/axios';

export default class ArquivoFolhaTotvsRMService {

    salvar(requisicao) {       
        return http.post('/api/documento/arquivo-folha-totvs-rm/salvar', requisicao);
    }

    listar(requisicao) {       
        return http.post('/api/documento/arquivo-folha-totvs-rm/listar', requisicao);
    } 
    
    exportarArquivoFolha(requisicao) {       
        return http.post('/api/documento/arquivo-folha-totvs-rm/folha-pag', requisicao, {responseType: 'blob'});
    } 
}